import { render, staticRenderFns } from "./DebitCard.vue?vue&type=template&id=e2824672&scoped=true"
import script from "./DebitCard.vue?vue&type=script&lang=js"
export * from "./DebitCard.vue?vue&type=script&lang=js"
import style0 from "./DebitCard.vue?vue&type=style&index=0&id=e2824672&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2824672",
  null
  
)

export default component.exports